import { DropdownMenu } from '@shared/components';
import { DatePicker } from '@shared/components/date-picker/DatePicker';
import { DropdownQueryParam } from 'clerk_common/constants/urls/queryParams';
import { ReactElement } from 'react';
import { FILTER_SUB_CONTENT_CLASS_NAME } from '../data-table-filters/classNames';
import { FilterSubMenuTrigger } from '../data-table-filters/components';
import { useDateRangeFilter } from './useDateRangeFilter';

export type DateRangeMenuItemProps = {
  label: string;
  startDateQueryParam: DropdownQueryParam;
  endDateQueryParam: DropdownQueryParam;
};

export function DateRangeMenuItem({
  label,
  startDateQueryParam,
  endDateQueryParam,
}: DateRangeMenuItemProps): ReactElement {
  const { clearDateRange, dateRange, setDateRange, submitDateRange } =
    useDateRangeFilter({
      startParam: startDateQueryParam,
      endParam: endDateQueryParam,
    });

  return (
    <DropdownMenu.Sub>
      <FilterSubMenuTrigger label={label} />
      <DropdownMenu.SubContent className={FILTER_SUB_CONTENT_CLASS_NAME}>
        <div className="p-2">
          <DatePicker
            handleClearSelection={clearDateRange}
            values={dateRange}
            onChange={setDateRange}
            onSubmit={submitDateRange}
          />
        </div>
      </DropdownMenu.SubContent>
    </DropdownMenu.Sub>
  );
}
